<template>
    <div>
        <p v-if="!loaded"><i class="fas fa-spinner fa-spin"></i> Loading data</p>
        <template v-else>
            <div data-slider class="feed-widget" ref="feedSlider" v-if="length > 0">
                <div class="swiper-wrapper">
                    <div class="slide" v-for="(record, index) in records" :key="index">
                        <slot name="item" :record="record"></slot>
                    </div>
                </div>
                <slot name="navigation" :show="showNavigation"></slot>
            </div>
            <div v-else>
                <p>There are no records available.</p>
            </div>
        </template>
    </div>
</template>
<script>
    import Swiper from 'swiper';
    import AjaxCaller from '../../mixins/AjaxCaller';
    export default {
        mixins: [AjaxCaller],
        data() {
            return {
                loaded: false,
                records: [],
                length: 0,
                showNavigation: false,
            }
        },
        mounted() {
            this.makeCall(this.success, this.failure);
        },
        methods: {
            success(response) {
                this.loaded = true;
                if (!response.data.records) {
                    return;
                }
                this.records = response.data.records;
                this.length = this.records.length;
                if (this.length < 2) {
                    return;
                }
                this.showNavigation = true;
                setTimeout(() => {
                    this.initiateSlider();
                }, 1000);
            },
            initiateSlider() {

                let element = this.$refs.feedSlider,
                    slides = element.getElementsByClassName('slide'),
                    effect = element.dataset.effect,
                    speed = element.dataset.speed,
                    delay = element.dataset.delay,
                    pagination = element.getElementsByClassName('swiper-pagination');

                if (slides.length < 2) {
                    element.setAttribute('class', 'disabled');
                    return;
                }

                (new Swiper(element, {
                    effect: effect === undefined ? 'slide' : effect,

                    slideClass: 'slide',
                    slideActiveClass: 'slide-active',
                    slideVisibleClass: 'slide-visible',
                    slideDuplicateClass: 'slide-duplicate',
                    slideNextClass: 'slide-next',
                    slidePrevClass: 'slide-prev',

                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },

                    pagination: {
                        el: pagination,
                        type: 'bullets',
                        clickable: true
                    },

                    slidesPerView: 1,
                    paginationClickable: true,
                    spaceBetween: 0,
                    loop: true,
                    speed: speed === undefined ? 2000 : speed,
                    autoplay: {
                        delay: delay === undefined ? 5000 : delay,
                    },
                    autoplayDisableOnInteraction: false,

                    parallax: true,
                    a11y: true
                }));
            },
            failure(error) {
                this.stopProcessing();
                console.log(error);
            }
        }
    }
</script>